const PropTypes = require("prop-types");
/**
 * Created by adderlyjaureguicampos on 08/12/16.
 */
const React = require("react");

const { formatText } = require("core/i18n").i18n;
const TaxationData = require("../TaxationData/TaxationData");
require("./taxDataList.scss");

const utilities = require("../../../utilities/formHelper");
import { fiocAddTaxationTagging } from "utilities/taggingInfo/fiocTags";

import { validateTin } from "actions/tinValidation";

class TaxationDataList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            taxationDataList:
                this.props.values.length >= 1
                    ? this.props.values
                    : [
                          {
                              taxCountry: "",
                              tin: "",
                              imt: "",
                              valid: true,
                          },
                      ],
            count: this.props.values.length >= 1 ? this.props.values.length : 0,
        };

        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleTaxationDataAdder = this.handleTaxationDataAdder.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.handleChangeTin = this.handleChangeTin.bind(this);
    }

    componentWillMount() {
        this.props.dataReceiver(this.state.taxationDataList);
    }

    onBlur(event, formId) {
        this.props.handleOnBlur && this.props.handleOnBlur(event, formId);
    }

    handleChangeTin(event, formId) {
        let taxationDataList = this.state.taxationDataList;
        taxationDataList[formId].tin = event.target.value;

        const { tin, taxCountry } = taxationDataList[formId];
        validateTin(taxCountry, tin).then((response) => {
            taxationDataList[formId].valid = response;
        });

        this.setState({ taxationDataList });
        this.props.dataReceiver(taxationDataList);
    }


    onFocus(event, formId) {
        const { handleOnFocus } = this.props;
        handleOnFocus && handleOnFocus(event, formId);
    }

    onChange(event, formId) {
        let taxationDataList = this.state.taxationDataList;
        taxationDataList[formId].valid = true;

        if (utilities.isNumber(event.value)) {
            taxationDataList[formId].imt = event.value;
            this.setState({
                taxationDataList: taxationDataList,
            });
        } else {
            taxationDataList[formId].taxCountry = event.value;
            this.setState({
                taxationDataList: taxationDataList,
            });
        }

        this.props.dataReceiver(taxationDataList);
    }

    onRemove(formId) {
        let taxationDataList = this.state.taxationDataList;
        let count = this.state.count - 1;

        taxationDataList = taxationDataList.filter(function (item, i) {
            item;
            return i != formId;
        });

        this.setState({
            taxationDataList: taxationDataList,
            count: count,
        });

        this.props.dataReceiver(taxationDataList);
    }

    handleTaxationDataAdder() {
        let taxationDataList = this.state.taxationDataList;
        let count = this.state.count + 1;

        taxationDataList.push({
            taxCountry: "",
            tin: "",
            imt: "",
            valid: true,
        });
        this.setState({
            taxationDataList: taxationDataList,
            count: count,
        });
        this.props.dataReceiver(taxationDataList);
        fiocAddTaxationTagging();
    }

    handleInvalidTinErrors = (index) => {
        const { errorsState, disableFinishButton } = this.props;
        const { valid } = this.state.taxationDataList[index];

        let errors = errorsState.get ? errorsState.toJS() : errorsState;
        errors = errors[1] || errors;

        if (errors[index]) {
            return errors[index];
        }

        if (!valid) {
            disableFinishButton(true)
            return {
                taxCountry: false,
                tin: false,
                imt: false,
                valid: true,
            };
        }

        disableFinishButton(false)
        return { taxCountry: false, tin: false, imt: false, valid: false };
    };

    render() {
        const { maxTributationCountries, taxCountryOptions } = this.props;
        const { taxationDataList } = this.state
        let taxationDataForms = [];
        let classAddTax =
            taxationDataList.length <= maxTributationCountries - 1
                ? "add-taxation col-xs-12"
                : "hidden";
        let showRemove =
            taxationDataList.length > 1 &&
            taxationDataList.length <= maxTributationCountries;

        if (taxationDataList.length >= 1) {
            taxationDataList.forEach((_, index) => {
                const errors = this.handleInvalidTinErrors(index);
                taxationDataForms.push(
                    <TaxationData
                        key={index}
                        taxCountryOptions={taxCountryOptions}
                        imtOptions={this.props.imtOptions}
                        handleChange={this.onChange}
                        handleBlur={this.onBlur}
                        handleFocus={this.onFocus}
                        handleRemove={this.onRemove}
                        showRemove={showRemove}
                        formData={taxationDataList[index]}
                        formId={index}
                        errorState={errors}
                        handleChangeTin={this.handleChangeTin}
                    />
                );
            });
        }
        return (
            <div className="taxation-data">
                {taxationDataForms}
                <div className={classAddTax}>
                    <a
                        href="javascript:void(0);"
                        onClick={this.handleTaxationDataAdder}
                    >
                        <i className="icon icon-add-red"></i>
                        {formatText(
                            "contractsView-checkingAccountTaxationDataListAddCountry"
                        )}
                    </a>
                </div>
            </div>
        );
    }
}

TaxationDataList.propTypes = {
    dataReceiver: PropTypes.func,
    taxCountryOptions: PropTypes.array,
    imtOptions: PropTypes.array,
    values: PropTypes.any.isRequired,
    errorsState: PropTypes.any.isRequired,
    maxTributationCountries: PropTypes.number,
    disableFinishButton: PropTypes.func
};

TaxationDataList.defaultProps = {
    maxTributationCountries: 4,
};

module.exports = TaxationDataList;
